import React, { useEffect } from 'react'
import { useTranslation } from '../../../hooks/useTranslation'
import { useExercise } from '../ExerciseProvider'
import { ReturnToResourceCenter } from '../Buttons'
import {
  CalendarIcon,
  ConclusionPageImage,
  ExerciseIcon,
  PersonIcon,
} from '../icons'
import { useIsMobile } from '../../../hooks/useMediaQuery'

const LinkedinVisibilitySelfAuditConclusion = () => {
  const {
    formattedExerciseName,
    dateAndTimeUpdated,
    candidateFirstName,
    ssoName,
    trackContent,
  } = useExercise()
  const { t } = useTranslation(formattedExerciseName)

  useEffect(() => {
    window.scrollTo({ top: 0 })
  }, [])

  const { yesCount, noCount } = getAuditCounts(trackContent)

  return (
    <div className="exercise mb-0">
      <Header
        t={t}
        ssoName={ssoName}
        candidateFirstName={candidateFirstName}
        dateAndTimeUpdated={dateAndTimeUpdated}
      />
      <SummaryContent t={t} yesCount={yesCount} noCount={noCount} />
    </div>
  )
}

const Header = ({ t, ssoName, candidateFirstName, dateAndTimeUpdated }) => {
  const isMobile = useIsMobile()
  const { t: tExercise } = useTranslation('exercise')

  return (
    <div className="bg-intoo-blue-dark text-white">
      <div
        className={`${
          isMobile ? 'mx-4' : 'mx-8'
        } flex items-center justify-between ${isMobile ? 'pb-10' : 'pb-14'}`}
      >
        <div>
          <h1 className="mb-0 mt-10 !font-roboto-slab text-2xl text-[32px] font-medium leading-normal !text-white">
            {t('start_exercise.title')}
          </h1>
          <hr className="!b-0 my-4 h-[1px] w-32 bg-white text-white" />
          <div className="flex flex-col !font-roboto-slab text-[20px] sm:flex-row">
            {!ssoName && (
              <div
                className={`${
                  isMobile ? 'mb-4' : ''
                } mr-0 flex items-center sm:mr-12`}
              >
                <div className="mr-4">
                  <PersonIcon />
                </div>
                {tExercise('results', { candidateName: candidateFirstName })}
              </div>
            )}
            <div className="flex items-center">
              <div className="mr-4">
                <CalendarIcon />
              </div>
              {dateAndTimeUpdated}
            </div>
          </div>
        </div>
        <div className="mt-10 flex">
          <ExerciseIcon />
        </div>
      </div>
    </div>
  )
}

const SummaryContent = ({ t, yesCount, noCount }) => {
  const isMobile = useIsMobile()
  const { retakeExercise } = useExercise()
  const { t: tExercise } = useTranslation('exercise')

  return (
    <div
      className={`summary-content ${
        isMobile ? 'p-6' : 'p-10'
      } flex flex-col bg-[#E0F2F9]`}
    >
      <div
        className={`rounded-[20px] bg-white ${
          isMobile ? 'px-4 py-12' : 'px-12 py-12'
        }`}
      >
        <div className="text-center">
          <h2 className="mb-4 text-2xl font-semibold">
            {t('conclusion_great_job')}
          </h2>
          <p className="!mb-6 font-roboto text-base font-normal">
            {t('conclusion_p1')}
          </p>
          <div className="mx-auto my-6 flex justify-center">
            <ConclusionPageImage />
          </div>
          <div className="mx-auto !mb-6 max-w-md rounded-[16px] bg-[#F7FAFC] px-6 py-4 text-left">
            <p className="!mb-2 font-roboto text-base font-medium text-[#2F2F2F]">
              {t('start_exercise.questions_total')}
            </p>
            <p className="!mb-1 font-roboto text-sm text-[#2F2F2F]">
              Yes responses: <span className="font-semibold">{yesCount}</span>
            </p>
            <p className="!mb-0 font-roboto text-sm text-[#2F2F2F]">
              No responses: <span className="font-semibold">{noCount}</span>
            </p>
          </div>
        </div>
        <div className="flex flex-col">
          <div className="flex justify-center">
            <a
              onClick={retakeExercise}
              className="mt-4 cursor-pointer !underline"
            >
              {tExercise('retake_exercise')}
            </a>
          </div>
        </div>
      </div>
      <ReturnToResourceCenter />
    </div>
  )
}

const getAuditCounts = (trackContent) => {
  let yesCount = 0
  let noCount = 0

  Object.values(trackContent).forEach((section) => {
    if (!section || typeof section !== 'object') return

    Object.values(section).forEach((answer) => {
      const normalized = normalizeAnswer(answer)
      if (normalized === true) yesCount += 1
      if (normalized === false) noCount += 1
    })
  })

  return { yesCount, noCount }
}

const normalizeAnswer = (answer) => {
  if (
    answer === true ||
    answer === 'true' ||
    answer === 'yes' ||
    answer === 'a'
  ) {
    return true
  }
  if (
    answer === false ||
    answer === 'false' ||
    answer === 'no' ||
    answer === 'b'
  ) {
    return false
  }

  return null
}

export default LinkedinVisibilitySelfAuditConclusion
